import React, {useEffect, useState} from 'react';
import { Check, ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
// import qrcode from '../images/qr-sample.jpg';
// import Klflogo from '../images/logo/ILFK-logo-2.png';
// import Navbar from './Navbar';
import { toPng } from 'html-to-image'; 
import { message, message as messages } from "antd";
import MainHeader from './components/MainHeader';
import Footer from '../site/components/Footer';
import { CheckCircle, Download, Calendar, Mail, MapPin } from 'lucide-react';

const AttendeSuccessPage = () => {

  const navigate = useNavigate();
  const [qrcode, setQrcode] = useState({})
  const [messageApi, contextHolder] = message.useMessage();

  const handleHome = () => {
      navigate('/');
  }

  const success = () => {
    messageApi.open({
      type: 'info',
      content: 'A ticket has been mailed to your email id also. Please check spam folder if you are not able to find it',
      className: 'custom-class',
      style: {
        marginTop: '10vh',
      },
      duration: 10, // sets the duration to 10 seconds
    });
  };
  

  const downloadStampCard = () => {

    
    const stampCard = document.getElementById('stampCard'); // Get the stamp card element

    // Check if the stampCard exists
    if (!stampCard) {
        console.error('Stamp card element not found');
        return; // Exit if the element is not found
    }

    toPng(stampCard)
        .then((dataUrl) => {
            const link = document.createElement('a');
            link.download = 'entry-pass.png'; // Set the filename
            link.href = dataUrl;
            document.body.appendChild(link); // Append link to body
            link.click(); // Trigger the download
            document.body.removeChild(link); // Remove link from body
            success();
        })
        .catch((error) => {
            console.error('Error downloading the entry-pass:', error);
        });
};

 

  const currentDate = new Date();
  const formattedDate = currentDate.toLocaleString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  });

  
  useEffect(() => {
    const qrData = JSON.parse(sessionStorage.getItem('qrdata'));
    setQrcode(qrData)
  }, []);

  return (
    <>
      <MainHeader/>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-orange-50">
        {/* Success Header - Made padding tighter */}
        <div className="bg-white shadow-sm border-b">
          <div className="max-w-6xl mx-auto px-4 py-6 sm:py-4">
            <div className="text-center">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-green-100 rounded-full mb-3">
                <CheckCircle className="w-7 h-7 text-green-600" />
              </div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-1">Thank You!</h1>
              <p className="text-base sm:text-lg text-gray-600 mb-3">
                Your registration has been successfully processed
              </p>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-1 sm:gap-2 text-xs sm:text-sm text-gray-500">
                <Mail className="w-3 h-3 sm:w-4 sm:h-4" />
                <span>A ticket has been mailed to your email. Please check spam folder if you don't see it.</span>
              </div>
              <div className="flex items-center justify-center gap-2 mt-2 text-xs sm:text-sm">
                <Calendar className="w-3 h-3 sm:w-4 sm:h-4 text-gray-400" />
                <span className="text-gray-600">Order Date: </span>
                <span className="font-semibold text-gray-900">{formattedDate}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content - Reduced vertical spacing */}
        <div className="max-w-6xl mx-auto px-4 py-6 sm:py-8">
          <div className="grid lg:grid-cols-2 gap-6 sm:gap-8 md:gap-12 items-start">
            
            {/* Registration Details - Tightened spacing */}
            <div className="space-y-4 sm:space-y-5">
              <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-start gap-3 mb-4">
                  <MapPin className="w-5 h-5 text-orange-500 mt-1 flex-shrink-0" />
                  <div>
                    <h2 className="text-lg sm:text-xl font-semibold text-gray-900 mb-1 sm:mb-2">
                      Registration Confirmed
                    </h2>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                      This confirms your registration for <span className="font-semibold text-orange-600">The International Literature Festival Of Kerala</span>. 
                      We're excited to have you join us for this incredible literary celebration.
                    </p>
                  </div>
                </div>
                
                <div className="border-t pt-4">
                  <h3 className="font-semibold text-gray-900 mb-2">Event Details:</h3>
                  <div className="space-y-1 text-sm text-gray-600">
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-blue-500 rounded-full"></div>
                      <span>Kerala Sahithya Academy, Thrissur</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                      <span>August 17-21, 2025</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Entry Pass Card - Made more compact */}
            <div className="flex justify-center">
              <div id="stampCard" className="bg-white rounded-2xl shadow-2xl p-6 w-full max-w-xs sm:max-w-sm hover:scale-105 transition-transform duration-300">
                <div className="text-center space-y-4">
                  {/* Header */}
                  <div className="bg-gradient-to-r from-orange-50 to-blue-50 rounded-lg p-3 shadow-inner">
                    <div className="text-lg sm:text-xl font-semibold text-gray-700 uppercase tracking-wider">
                      Entry Pass
                    </div>
                  </div>

                  {/* Attendee Info */}
                  <div className="space-y-3 text-left bg-gray-50 p-3 rounded-lg">
                    <div className="flex flex-col">
                      <span className="text-xs sm:text-sm font-medium text-gray-500">ILFK ID</span>
                      <span className="text-base sm:text-lg font-semibold text-gray-800 break-all">
                        {qrcode?.mergedData || 'N/A'}
                      </span>
                    </div>
                    
                    <div className="flex flex-col">
                      <span className="text-xs sm:text-sm font-medium text-gray-500">Full Name</span>
                      <span className="text-base sm:text-lg font-semibold text-gray-800">
                        {qrcode?.name || 'N/A'}
                      </span>
                    </div>
                  </div>

                  {/* Footer */}
                  <div className="pt-4 border-t border-gray-200 space-y-1">
                    <div className="text-xs text-gray-500">
                      The International Literature Festival Of Kerala
                    </div>
                    <div className="h-7 bg-gradient-to-r from-orange-200 to-blue-200 rounded flex items-center justify-center shadow-inner">
                      <span className="text-xs font-semibold text-gray-700">ILFK 2025</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Download Button - Adjusted margin */}
          <div className="text-center mt-8 sm:mt-10">
            <button 
              onClick={downloadStampCard}
              className="inline-flex items-center gap-2 bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white font-semibold px-6 py-3 sm:px-8 sm:py-3 rounded-xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-300 text-sm sm:text-base"
            >
              <Download className="w-4 h-4 sm:w-5 sm:h-5" />
              Download Entry Pass
            </button>
          </div>
        </div>

        {/* Decorative Elements */}
        <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
          <div className="absolute top-20 left-10 w-16 h-16 bg-orange-200 rounded-full opacity-20 animate-pulse"></div>
          <div className="absolute top-32 right-16 w-14 h-14 bg-blue-200 rounded-full opacity-20 animate-pulse delay-1000"></div>
          <div className="absolute bottom-32 left-16 w-10 h-10 bg-green-200 rounded-full opacity-20 animate-pulse delay-2000"></div>
        </div>
      </div>
      <Footer/>
    </>
  );
};

export default AttendeSuccessPage;